<template>
  <div class="modal-content new-product">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Create new...') }}</h4>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label for="newProductName">{{ _('Name') }}</label>
        <input ref="name" class="form-control" type="text" id="newProductName" v-model="name" :placeholder="_('Enter a name for the new product or category')" />
      </div>


      <editor-tabs :tabs="tabList" :selected="activeProductTab" :id-prefix="tabIdPrefix" v-on:select="productTab" />

      <div class="tab-content">
        <div id="collapseNew" :class="productTabPaneClass('new')" role="tabpanel">
          <template v-if="!selectedType">
            <div class="template-wrap new">
              <template v-for="productType in productTypes">
                <button type="button" :class="productTypeClass(productType, 'newProduct')" v-on:click="selectType(productType)"><i class="hidden fa fa-fw fa-5x fa-cube"></i><span class="desc">{{ productType.title }}</span><span v-if="productType.subtypetitle"><br /><small class="desc">{{ productType.subtypetitle }}</small></span></button>{{ ' ' }}
              </template>
              <button v-if="showCategoryType" type="button" class="btn btn-default newCategory" v-on:click="selectCategory"><strong class="desc">{{ _('Category') }}</strong></button>
            </div>
          </template>
          <template v-else>
            <div v-if="selectedType === 'category'" class="form-group single-template producttypes template-wrap">
              <button type="button" class="btn btn-default newCategory selectedType" v-on:click="selectNone"><strong class="desc">{{ _('Category') }}</strong></button>
            </div>
            <div v-else class="form-group producttypes single-template template-wrap">
              <button type="button" :class="productTypeClass(selectedType, 'newProduct') + ' selectedType'" v-on:click="selectNone"><i class="hidden fa fa-fw fa-5x fa-cube"></i><strong class="desc">{{ selectedType.title }}</strong><span v-if="selectedType.subtypetitle"><br /><small class="desc">{{ selectedType.subtypetitle }}</small></span></button>
            </div>
          </template>
        </div>

        <div id="collapseCopy" :class="productTabPaneClass('copy')" role="tabpanel">
          <div class="form-group">
          <label for="availability">{{ _('Product') }}</label>
          <v-select :options="filteredProducts" v-model="selectedCopyProduct" label="name" keys="['name']" :placeholder="_('Type to search products')" :create-item="false">
            <template v-slot:no-options="{ searching }">
              <template v-if="searching">
                {{ _('No results found.') }}
              </template>
              <template v-else>{{ _('Type to search products') }}</template>
            </template>
            <template v-slot:option="option">
              <span>{{ option.name }}<template v-if="option.shopid !== shopId"> ({{ option.shopid }})</template></span><span class="item-type to-right">{{ productType(option) }}</span>
            </template>
          </v-select>
          </div>
          <div v-if="selectedCopyProduct" class="form-group">
            <label for="availability">{{ _('Availability') }}</label>
            <select id="availability" v-model="availability" class="form-control">
              <option value="link">{{ _('Link to the availability and capacity of the original product') }}</option>
              <option value="new">{{ _('Setup new availability and capacity') }}</option>
            </select>
          </div>
        </div>

        <div id="collapseLibrary" :class="productTabPaneClass('library')" role="tabpanel">
          <div class="form-group product-library">
            <h2>{{ _('Johku Product Library') }}</h2>
            <div class="product-library-search" v-if="!selectedLibraryProduct">
              <input class="form-control" :placeholder="(selectedLibraryCategory ? _('Search this category') : _('Search the product library'))" v-model="productLibrarySearchQuery" v-on:keyup.enter="searchThisProductLibrary"/>
              <button class="btn btn-primary" @click="searchThisProductLibrary()"><i class="fa fa-fw fa-search"></i></button>
            </div>
            <div class="product-library-tags" v-if="selectedLibraryTag || productLibraryTags">
              <template v-if="selectedLibraryTag">
                <a :class="'label label-lg tag ' + materialColorClass(selectedLibraryTag)" @click.stop="deselectTag(selectedLibraryTag)">{{ selectedLibraryTag }}<i class="fa fa-fw fa-close"></i></a>
              </template>
              <template v-else>
                <a :class="'label label-lg tag ' + materialColorClass(tag)" v-for="tag in productLibraryTags" @click="tagClick(tag)">{{ tag }}</a>
              </template>
            </div>
            <div class="product-library-header">
              <div class="product-library-breadcrumb">
                <a class="product-library-breadcrumb-item category clickable" @click="activateProductLibraryTab('main')"><i :class="'fa fa-fw fa-folder' + (selectedLibraryCategory ? '' : '-open')"></i> {{ _('Johku Product Library') }}</a>
                <a class="product-library-breadcrumb-item category clickable" v-if="selectedLibraryTag" @click="tagClick(selectedLibraryTag)"><i class="fa fa-fw fa-tag"></i> {{ selectedLibraryTag }}</a>
                <a class="product-library-breadcrumb-item category clickable" v-if="selectedLibraryCategory" @click="activateProductLibraryTab('category')"><i :class="'fa fa-fw fa-folder' + (selectedLibraryProduct || searchResults ? '' : '-open')"></i> {{ selectedLibraryCategory.name }}</a>
                <a class="product-library-breadcrumb-item category clickable" v-if="searchActive && !selectedLibraryTag" @click="activateProductLibraryTab('search')"><i :class="'fa fa-fw fa-folder' + (selectedLibraryProduct ? '' : '-open')"></i> {{ _('Search results') }}</a>
                <a class="product-library-breadcrumb-item category clickable" v-if="showLocalTemplates" @click="activateProductLibraryTab('localtemplates')"><i :class="'fa fa-fw fa-folder' + (selectedTemplate ? '' : '-open')"></i> {{ _('Local templates')}}</a>
                <a class="product-library-breadcrumb-item category clickable" v-if="showOtherTemplates" @click="activateProductLibraryTab('othertemplates')"><i :class="'fa fa-fw fa-folder' + (selectedTemplate ? '' : '-open')"></i> {{ _('Shared templates')}}</a>
                <a class="product-library-breadcrumb-item product clickable" v-if="selectedLibraryProduct"></a>
              </div>
            </div>
            <template v-if="!selectedLibraryCategory && !searchActive && !selectedLibraryProduct && !showOtherTemplates && !showLocalTemplates">
              <div class="product-library-list categories"> <!-- Show category list -->
                <div :class="'product-library-loading' + (loading ? ' product-library-loading-visible' : '')">
                  <i class="fa-solid fa-circle-notch fa-spin fa-2x"></i>
                </div>
                <template v-for="category in productLibraryCategories">
                  <div class="product-library-item category clickable" @click="selectedLibraryCategory = category">
                    <div class="product-library-item-icon">
                      <i class="fa fa-fw fa-folder"></i>
                    </div>
                    <div clas="product-library-item-text">
                      <h4 class="product-library-item-name">{{ category.name }}</h4>
                      <p class="product-library-item-description" v-if="category.description">{{ category.description }}</p>
                    </div>
                  </div>
                </template>
              </div>
              <div class="product-library-list categories" v-if="hasTemplates">
                <div class="product-library-item category clickable" @click="activateProductLibraryTab('localtemplates')" v-if="hasLocalTemplates">
                  <div class="product-library-item-icon">
                    <i class="fa fa-fw fa-folder-user"></i>
                  </div>
                  <div clas="product-library-item-text">
                    <h4 class="product-library-item-name">{{ _('Local templates')}}</h4>
                  </div>
                </div>
                <div class="product-library-item category templates clickable" @click="activateProductLibraryTab('othertemplates')" v-if="hasOtherTemplates">
                  <div class="product-library-item-icon">
                    <i class="fa fa-fw fa-folder-user"></i>
                  </div>
                  <div clas="product-library-item-text">
                    <h4 class="product-library-item-name">{{ _('Shared templates')}}</h4>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <template v-if="showLocalTemplates || showOtherTemplates">
                <template v-if="!selectedTemplate">
                  <template v-if="showLocalTemplates">
                    <div class="form-group template-container producttypes">
                      <div class="templateProductButtons" v-if="hasTemplates">
                        <template v-for="template in localTemplates" v-if="hasLocalTemplates">
                          <div class="template-wrap templates">
                            <template v-for="cat in template.sharedCategory">
                              <template v-for="prod in cat.sharedProduct">
                                <button type="button" :class="productTypeClass(prod, 'templateProduct')" v-on:click="selectTemplate(template, null, prod)"><i class="hidden fa fa-fw fa-5x fa-cube"></i><strong class="desc">{{ prod.name }}</strong><br><small class="desc">{{ cat.name }}</small></button>{{ ' ' }}
                              </template>
                            </template>
                          </div>
                        </template>
                      </div>
                    </div>
                  </template>
                  <template v-if="showOtherTemplates">
                    <div class="form-group template-container producttypes">
                      <div class="templateProductButtons" v-if="hasTemplates">
                        <template v-for="template in otherTemplates" v-if="hasOtherTemplates">
                          <template v-for="cat in template.sharedCategory">
                            <span class="template-category-separator" v-if="cat.sharedProduct.length"><span class="category-name">{{ cat.name }}</span><span class="category-shop"> / {{ template.saleschannel && template.saleschannel.title ? template.saleschannel.title : template.shopid }}</span></span>
                            <div class="template-wrap templates">
                              <template v-for="prod in cat.sharedProduct">
                                <button type="button" :class="productTypeClass(prod, 'templateProduct')" v-on:click="selectTemplate(template, null, prod)"><i class="hidden fa fa-fw fa-5x fa-cube"></i><strong class="desc">{{ prod.name }}</strong><br><small class="desc">{{ cat.name }}</small></button>{{ ' ' }}
                              </template>
                            </div>
                          </template>
                        </template>
                      </div>
                    </div>
                  </template>
                </template>
                <div v-else class="form-group single-template producttypes template-wrap">
                  <button type="button" :class="productTypeClass(selectedProduct, 'templateProduct') + ' selectedType'" v-on:click="selectNone"><i class="hidden fa fa-fw fa-5x fa-cube"></i><strong class="desc">{{ selectedProduct.name }}</strong></button>
                </div>
              </template>
              <template v-else>
                <template v-if="!selectedLibraryProduct"> <!-- Show product list -->
                  <div class="product-library-list products">
                    <div :class="'product-library-loading' + (loading ? ' product-library-loading-visible' : '')">
                      <i class="fa-solid fa-circle-notch fa-spin fa-2x"></i>
                    </div>
                    <div class="product-library-item product clickable" v-on:click="showPreviewModal(template.product.id)" v-for="template in productLibraryListSource">
                      <div clas="product-library-item-text">
                        <h4 class="product-library-item-name">{{ template.name }}</h4>
                        <div class="product-library-item-description" v-html="template.product.description"></div>
                        <div class="product-library-item-tags" v-if="template.product.tags.length">
                          <a :class="'label tag ' + materialColorClass(tag)" v-for="tag in template.product.tags" @click.stop="tagClick(tag)">{{ tag }}</a>
                        </div>
                      </div>
                      <div class="product-library-buttons">
                        <button class="btn btn-sm btn-default" v-on:click.stop="selectedLibraryProduct = template"><i class="fa fa-fw fa-check"></i> {{ _('Select') }}</button>
                        <button class="btn btn-sm btn-white" v-on:click.stop="showPreviewModal(template.product.id)"><i class="fa fa-fw fa-info"></i> {{ _('Details') }}</button>
                      </div>
                    </div>
                    <div v-if="!productLibraryListSource.length && !loading">
                      <div v-if="searchActive">{{ _('Nothing in the product library matched your query.') }}</div>
                      <div v-else>{{ _('This category does not contain any products at the moment.') }}</div>
                    </div>
                  </div>
                </template>
                <template v-else> <!-- Show single product -->
                  <div class="product-library-product-details clickable" v-if="selectedLibraryProduct" v-on:click="showPreviewModal(selectedLibraryProduct.product.id)">
                    <div :class="'product-library-loading' + (loading ? ' product-library-loading-visible' : '')">
                      <i class="fa-solid fa-circle-notch fa-spin fa-2x"></i>
                    </div>
                    <button class="close" @click.stop="selectedLibraryProduct = null">&times;</button>
                    <div clas="product-library-item-text">
                      <h4 class="product-library-item-name">{{ selectedLibraryProduct.name }}</h4>
                      <div class="product-library-item-description" v-html="selectedLibraryProduct.product.description"></div>
                      <div class="product-library-item-tags" v-if="selectedLibraryProduct.product.tags.length">
                        <a :class="'label tag ' + materialColorClass(tag)" v-for="tag in selectedLibraryProduct.product.tags" @click.stop="tagClick(tag)">{{ tag }}</a>
                      </div>
                    </div>
                    <div class="product-library-buttons">
                      <button class="btn btn-sm btn-success" style="pointer-events: none;"><i class="fa fa-fw fa-check"></i> {{ _('Selected') }}</button>
                      <button class="btn btn-sm btn-default" @click.stop="selectedLibraryProduct = null"><i class="fa fa-fw fa-close"></i> {{ _('Change') }}</button>
                    </div>
                  </div>
                </template>
              </template>
            </template>
          </div>
        </div>
  
        <div id="collapseTemplates" :class="productTabPaneClass('template')" role="tabpanel" v-if="!isFeatureEnabled('productlibrary')">
          <template v-if="!selectedTemplate">
            <div class="form-group template-container producttypes">
              <div class="templateProductButtons" v-if="hasTemplates">
                <span v-if="hasLocalTemplates" :class="'template-separator templates ' + (visibility.local || search ? 'open' : 'closed')" v-on:click="toggle('local')">{{ _('Local templates') }}<span v-if="!search" class="toggle-visibility" :data-open="_('Close')" :data-closed="_('Show')"></span></span>
                <template v-for="template in localTemplates" v-if="hasLocalTemplates">
                  <div class="template-wrap templates">
                    <template v-for="cat in template.sharedCategory" v-if="visibility.local || search">
                      <template v-for="prod in cat.sharedProduct">
                        <button type="button" :class="productTypeClass(prod, 'templateProduct')" v-on:click="selectTemplate(template, null, prod)"><i class="hidden fa fa-fw fa-5x fa-cube"></i><strong class="desc">{{ prod.name }}</strong><br><small class="desc">{{ cat.name }}</small></button>{{ ' ' }}
                      </template>
                    </template>
                  </div>
                </template>
                <span v-if="hasGlobalTemplates" :class="'template-separator templates ' + (visibility.global || search ? 'open' : 'closed')" v-on:click="toggle('global')">{{ _('Global templates') }}<span v-if="!search" class="toggle-visibility" :data-open="_('Hide')" :data-closed="_('Show')"></span></span>
                <template v-for="template in globalTemplates" v-if="hasGlobalTemplates">
                  <template v-for="cat in template.sharedCategory" v-if="visibility.global || search">
                    <span class="template-category-separator" v-if="cat.sharedProduct.length"><span class="category-name">{{ cat.name }}</span></span>
                    <div class="template-wrap">
                      <template v-for="prod in cat.sharedProduct">
                        <button type="button" :class="productTypeClass(prod, 'templateProduct')" v-on:click="selectTemplate(template, null, prod)"><i class="hidden fa fa-fw fa-5x fa-cube"></i><strong class="desc">{{ prod.name }}</strong><br><small class="desc">{{ cat.name }}</small></button>{{ ' ' }}
                      </template>
                    </div>
                  </template>
                </template>
                <span v-if="hasOtherTemplates" :class="'template-separator templates ' + (visibility.other || search ? 'open' : 'closed')" v-on:click="toggle('other')">{{ _('Other templates') }}<span v-if="!search" class="toggle-visibility" :data-open="_('Hide')" :data-closed="_('Show')"></span></span>
                <template v-for="template in otherTemplates" v-if="hasOtherTemplates">
                  <template v-for="cat in template.sharedCategory" v-if="visibility.other || search">
                    <span class="template-category-separator" v-if="cat.sharedProduct.length"><span class="category-name">{{ cat.name }}</span><span class="category-shop"> / {{ template.saleschannel && template.saleschannel.title ? template.saleschannel.title : template.shopid }}</span></span>
                    <div class="template-wrap templates">
                      <template v-for="prod in cat.sharedProduct">
                        <button type="button" :class="productTypeClass(prod, 'templateProduct')" v-on:click="selectTemplate(template, null, prod)"><i class="hidden fa fa-fw fa-5x fa-cube"></i><strong class="desc">{{ prod.name }}</strong><br><small class="desc">{{ cat.name }}</small></button>{{ ' ' }}
                      </template>
                    </div>
                  </template>
                </template>
              </div>
            </div>
          </template>
          <div v-else class="form-group single-template producttypes template-wrap">
            <button type="button" :class="productTypeClass(selectedProduct, 'templateProduct') + ' selectedType'" v-on:click="selectNone"><i class="hidden fa fa-fw fa-5x fa-cube"></i><strong class="desc">{{ selectedProduct.name }}</strong></button>
          </div>
        </div>
      </div>
      <!--
      <div v-if="selectedTemplate" class="form-group single-template producttypes template-wrap">
        <button type="button" :class="productTypeClass(selectedProduct, 'templateProduct') + ' selectedType'" v-on:click="selectNone"><i class="hidden fa fa-fw fa-5x fa-cube"></i><strong class="desc">{{ selectedProduct.name }}</strong><br><small class="desc">{{ selectedCategory ? selectedCategory.name : _('Not selected') }}</small></button>
      </div>
      <div v-else-if="selectedType === 'category'" class="form-group single-template producttypes template-wrap">
        <button type="button" class="btn btn-default newCategory selectedType" v-on:click="selectNone"><strong class="desc">{{ _('Category') }}</strong></button>
      </div>
      <div v-else-if="selectedType" class="form-group producttypes single-template template-wrap">
        <button type="button" :class="productTypeClass(selectedType, 'newProduct') + ' selectedType'" v-on:click="selectNone"><i class="hidden fa fa-fw fa-5x fa-cube"></i><strong class="desc">{{ selectedType.title }}</strong><span v-if="selectedType.subtypetitle"><br /><small class="desc">{{ selectedType.subtypetitle }}</small></span></button>
      </div>
      -->
      <div class="row" v-if="selectedType !== 'category'">
        <div class="col-xs-12">
          <div class="form-group">
            <label for="selectedCategory">{{ _('Add to category') }}</label>
            <select class="form-control" id="selectedCategory" v-model="selectedCategory">
              <option :value="null">{{ _('Not selected') }}</option>
              <optgroup :label="_('Active categories')" v-if="filteredOpenCategories && filteredOpenCategories.length">
                <option v-for="category in filteredOpenCategories" :value="category.id">{{ category.name }}</option>
              </optgroup>
              <optgroup :label="_('All categories')">
                <option v-for="category in categoryOptions" :value="category.id">{{ category.name }}</option>
              </optgroup>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-success" v-on:click="selected" :disabled="!canSubmit"><i class="fa fa-fw fa-save"></i> {{ _('OK') }}</button>
    </div>
    <modal :name="previewModalId" :adaptive=true :width=1000 :maxWidth=1000 :maxHeight=500 :scrollable=true height="auto">
      <product-popup :product="previewLibraryProduct" :shopId="productLibraryShopId" :productShopId="productLibraryShopId" :baseDomain="'https://johku.com/'" :settings="settings" :locale="locale" :showTags="true" :hideMerchant="true" :showLinkedProducts="true" context="productlibrary" v-on:close="hidePreviewModal" v-on:action="selectPreviewLibraryProduct" v-on:linkedProductClick="linkedProductClick" v-on:tagClick="tagClick"></product-popup>
    </modal>
  </div>
</template>

<script>

import axios from 'axios'
import { mapGetters } from 'vuex'
import debounce from 'lodash/debounce'
import components from '~/lib/components'
import settingshelpers from '~/lib/settingshelpers'
import productlibrary from '~/lib/productlibrary'
import ProductPopup from '~/components/ProductPopup.vue'

export default {
  props: ['selectedProducts', 'openCategories'],
  data () {
    return {
      search: '',
      visibility: {
        local: true,
        global: false,
        other: false
      },
      activeProductTab: 'new',
      selectedTemplate: null,
      productLibraryTemplate: null,
      selectedCategory: null,
      selectedProduct: null,
      selectedCopyProduct: null,
      selectedType: null,
      name: '',
      products: [],
      allTemplates: [],
      productTemplates: [],
      allProductTypes: [],
      allCategories: [],
      filteredProducts: [],
      productLibraryCategories: [],
      selectedLibraryCategory: null,
      selectedLibraryCategoryProducts: [],
      selectedLibraryProduct: null,
      availability: 'link',
      productLibraryShopId: 'productlibrary',
      selectedLibraryProductData: null,
      productLibrarySearchQuery: '',
      selectedLibraryTag: '',
      productLibraryTags: [],
      previewLibraryProduct: null,
      selectedPreviewProduct: null,
      searching: false,
      loading: false,
      searchActive: false,
      searchResults: [],
      searchResultPage: 1,
      totalSearchResults: 0,
      showLocalTemplates: false,
      showOtherTemplates: false
    }
  },
  mixins: [settingshelpers, components, productlibrary],
  components: {
    ProductPopup
  },
  computed: {
    tabList () {
      return [
        { id: 'new', label: this._('Type') },
        { id: 'library', label: this._('Product library'), hidden: !this.isFeatureEnabled('productlibrary') },
        { id: 'template', label: this._('Product templates'), hidden: this.isFeatureEnabled('productlibrary') },
        { id: 'copy', label: this._('Copy') }
      ]
    },
    ...mapGetters(['shopId', 'baseDomain', 'locale', 'apiKey']),
    allCategoryIds () {
      return this.allCategories.map(c => c.id)
    },
    filteredOpenCategories () {
      return this.openCategories.filter(c => this.allCategoryIds.includes(c.id))
    },
    globalTemplates () {
      return this.productTemplates.filter(t => t.shopid === 'dev' || t.shopid.startsWith('dev_')).map(this.filterTemplates)
    },
    localTemplates () {
      return this.productTemplates.filter(t => t.shopid === this.shopId).map(this.filterTemplates)
    },
    otherTemplates () {
      return this.productTemplates.filter(t => t.shopid !== 'dev' && !t.shopid.startsWith('dev_') && t.shopid !== this.shopId).map(this.filterTemplates)
    },
    hasTemplates () {
      return this.productTemplates.length
    },
    hasGlobalTemplates () {
      return this.globalTemplates.length && this.globalTemplates.reduce(this.reduceTemplates, 0)
    },
    hasLocalTemplates () {
      return this.localTemplates.length && this.localTemplates.reduce(this.reduceTemplates, 0)
    },
    hasOtherTemplates () {
      return this.otherTemplates.length && this.otherTemplates.reduce(this.reduceTemplates, 0)
    },
    s () {
      return this.search.trim().toLowerCase()
    },
    productTypes () {
      return this.allProductTypes.filter(t => !this.s || t.title.toLowerCase().includes(this.s) || (t.subtypetitle && t.subtypetitle.toLowerCase().includes(this.s)))
    },
    showCategoryType () {
      return !this.s || this._('Category').toLowerCase().includes(this.s)
    },
    canSubmit () {
      return (this.selectedTemplate || this.selectedType || this.selectedCopyProduct || this.selectedLibraryProduct) && this.name
    },
    categoryOptions () {
      return this.allCategories.map(c => { return { id: c.id, name: c.name }; }).sort((a, b) => a.name > b.name ? 1 : -1)
    },
    productLibraryListSource () {
      if (this.searchActive) {
        return this.searchResults
      } else {
        return this.selectedLibraryCategoryProducts
      }
    },
    previewModalId () {
      return 'producttype-preview'
    }
  },
  methods: {
    async showPreviewModal (id) {
      if(!id) return
      let template = {}
      template.product = {}
      template.product.source_id = id
      template.product.id = id
      template.id = id
      this.selectedPreviewProduct = {}
      this.selectedPreviewProduct.name = ''
      this.selectedPreviewProduct.description = ''
      this.selectedPreviewProduct.id = template.id
      this.selectedPreviewProduct.shopid = this.productLibraryShopId
      this.productLibrarySearchQuery = ''

      await this.loadProductLibraryProduct(template.product.source_id ? template.product.source_id : template.product.id)
      if(!this.selectedLibraryProductData) {
        return
      }
      if(this.selectedLibraryProductData.enable_catalog === '0') {
        return
      }
      this.previewLibraryProduct = this.selectedLibraryProductData
      this.selectedPreviewProduct.name = this.selectedLibraryProductData.name
      this.selectedPreviewProduct.description = this.selectedLibraryProductData.description
      this.selectedPreviewProduct.product = this.previewLibraryProduct
      this.$modal.show(this.previewModalId)
    },
    selectPreviewLibraryProduct () {
      this.selectedLibraryProduct = this.selectedPreviewProduct
      this.hidePreviewModal()
    },
    hidePreviewModal () {
      this.previewLibraryProduct = null
      this.selectedPreviewProduct = null
      this.$modal.hide(this.previewModalId)
    },
    parseResultTags(tags) {
      let tagNames = []
      if (tags && tags.length) {
        for (let i = 0; i < tags.length; i++) {
          let defaultTagParts = tags[i].title.split(':::')
          let tagParts = tags[i].title.split(':::' + this.locale + ':::') 
          if (this.locale === this.settings.defaultversion && defaultTagParts.length === 2 && defaultTagParts[0] === 'product') {
            tagNames.push(defaultTagParts[1])
          } else if(tagParts.length == 2 && tagParts[0] === 'product') {
            tagNames.push(tagParts[1]) 
          }
        }
      }
      return tagNames
    },
    convertSearchResults(response) {
      this.searchResults = []
      response.forEach((item) => {
        let resultProduct = {...item.document}
        resultProduct.product  = {...item.document}
        resultProduct.source_id = resultProduct.product.source_id = resultProduct.product.id = resultProduct.id = resultProduct.localid
        this.searchResults.push(resultProduct)
      })
    },
    activateProductLibraryTab(tab) {
      this.showLocalTemplates = false
      this.showOtherTemplates = false
      this.selectedTemplate = false
      this.selectedType = false
      switch(tab) {  
        case 'main':
          this.selectedLibraryCategory = null
          this.selectedLibraryProduct = null
          this.deselectTag()
          this.closeProductLibrarySearch()
          return
        case 'category':
          this.selectedLibraryProduct = null
          this.deselectTag()
          this.closeProductLibrarySearch()
          return
        case 'search':
          this.selectedLibraryProduct = null
          return
        case 'product':
          return
        case 'localtemplates':
          this.selectedLibraryCategory = null
          this.selectedLibraryProduct = null
          this.deselectTag()
          this.closeProductLibrarySearch()
          this.showLocalTemplates = true
          return
        case 'othertemplates':
          this.selectedLibraryCategory = null
          this.selectedLibraryProduct = null
          this.deselectTag()
          this.closeProductLibrarySearch()
          this.showOtherTemplates = true
          return
      }
    },
    closeProductLibrarySearch() {
      this.searchResults = []
      this.productLibrarySearchQuery = ''
      this.searchActive = false
    },
    isNumber(value) {
      return !isNaN(Number(value)) && Number.isInteger(Number(value)) && Number(value) > 0
    },
    async searchThisProductLibrary(str) {
      if((typeof str === 'undefined' || !str) && this.productLibrarySearchQuery) {
        str = this.productLibrarySearchQuery
      }
      this.directSearchProductLibrary(str, this)
    },
    async directSearchProductLibrary(query, $this) {
      query = this.stripEmoji(query)

      if ($this.isNumber(query)) {
        $this.showPreviewModal(query)
        return
      }
      if(this.selectedLibraryTag && query != this.stripEmoji(this.selectedLibraryTag)) {
        query = this.stripEmoji(this.selectedLibraryTag) + ' ' + query
      }
      $this.searchActive = true
      $this.loading = true
      let libraryUrl = $this.baseDomain + $this.productLibraryShopId
      if ($this.baseDomain === 'https://johkutest.jalusta.com/') {
        libraryUrl = 'https://johku.com/' + $this.productLibraryShopId
      }
      let categoryStr = ''
      if ($this.selectedLibraryCategory) {
        categoryStr = '&category=' + $this.selectedLibraryCategory.id
      }
      axios.get(`${libraryUrl}/${$this.locale}/search.json?q=${query}${categoryStr}&templates=true`)
      .then(response => {
        $this.convertSearchResults(response.data.hits)
        $this.loading = false
      })
    },
    searchProductLibrary: debounce((query, $this) => {
      $this.directSearchProductLibrary(query, $this)
    }, 350),
    searchProducts(text) {
      if (!text) {
        this.filteredProducts = []
        return
      }
      this.filteredProducts = this.products.filter(p => p.name && p.name.toLowerCase().includes(text.toLowerCase()))
    },
    async selectProductToCopy (allProduct) {
      if (!allProduct) {
        return
      }
      //this.isProductPickerVisible = false
      /*let response
      try {
        response = await axios.get(this.baseDomain + allProduct.shopid + '/products/' + allProduct.source_id + '.json')
      } catch (e) {
        return
      }
      const product = response.data
        let data = {
          version: this.version,
          locale: this.locale,
          product: product,
          shopId: allProduct.shopid,
        }
        this.$store.dispatch('addToBasket', data)
        .then(() => {
          this.showAddedToBasketNotification(this.$filters.marketingname(product))
        })
        .catch((err) => {
          this.showAddedToBasketError(err)
        })
      }*/
      this.selectedCopyProduct = allProduct
    },
    async productTab(tab) {
      this.activeProductTab = tab
      switch (tab) {
        case 'copy':
          this.selectedProduct = null
          this.selectedTemplate = null
          this.selectedType = null
          this.selectedLibraryProduct = null
          this.selectedLibraryCategory = null
          break
        case 'template':
          this.selectedType = null
          this.selectedCopyProduct = null
          this.selectedLibraryProduct = null
          this.selectedLibraryCategory = null
          break
        case 'new':
          this.selectedProduct = null
          this.selectedLibraryProduct = null
          this.selectedLibraryCategory = null
          break
        case 'productlibrary':
          this.selectedProduct = null
          this.selectedTemplate = null
          this.selectedCopyProduct = null
          this.selectedLibraryProduct = null
          this.selectedLibraryCategory = null
          break
      }
      if (tab == 'copy' && !this.products.length) {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/allproducts.json?all=true&localonly=true&posnames=true&apikey=' + this.apiKey)
        } catch(e) {
          return
        }
        this.products = this.filteredProducts = response.data.filter(p => parseInt(p.subtype) !== this.SUBTYPE_CONTENT)
      }
    },
    isProductTabActive(tab) {
      return this.activeProductTab === tab
    },
    productTabClass(tab) {
      return this.isProductTabActive(tab) ? 'active' : ''
    },
    productTabPaneClass(tab) {
      return String('tab-pane ' + this.productTabClass(tab)).trim()
    },
    hideModal () {
      this.$emit('close')
    },
    selected () {
      if (this.selectedLibraryProduct) {
        this.selectedTemplate = {
          shopid: this.selectedLibraryProduct.shopid,
          source_id: (this.selectedLibraryProduct.source_id ? this.selectedLibraryProduct.source_id : this.selectedLibraryProduct.id)
        }
        this.selectedProduct = {
          shopid: this.selectedLibraryProduct.shopid,
          source_id: (this.selectedLibraryProduct.source_id ? this.selectedLibraryProduct.source_id : this.selectedLibraryProduct.id)
        }
      }
      this.$emit('selected', {
        selectedTemplate: this.selectedTemplate,
        selectedProduct: this.selectedProduct,
        selectedCopyProduct: this.selectedCopyProduct,
        selectedType: this.selectedType,
        selectedCategory: this.selectedCategory,
        name: this.name,
        availability: this.availability
      })
    },
    selectTemplate (template, category, product) {
      this.selectNone()
      this.selectedTemplate = template
      this.selectedCategory = category
      this.selectedProduct = product
      this.focusName()
    },
    selectCategory () {
      this.selectNone()
      this.selectedType = 'category'
      this.focusName()
    },
    selectType (type) {
      this.selectNone()
      this.selectedType = type
      this.focusName()
    },
    selectNone () {
      this.selectedTemplate = this.selectedProduct = this.selectedType = this.selectedCopyProduct = null
    },
    async focusName () {
      await nextTick()
      if (this.$refs.name && this.name === '') {
        this.$refs.name.focus()
      }
    },
    reduceTemplates (tc, t) { // Count the number of products in each category of a template definition
      return tc + (t.sharedCategory ? t.sharedCategory.reduce((cc, c) => cc + (c.sharedProduct ? c.sharedProduct.length : 0), 0) : 0)
    },
    filterTemplates (t) { // Filter the templates so that either the category name or the category's product name contains the current search, if any
      let t2 = { ...t }
      t2.sharedCategory = t.sharedCategory.map(c => {
        let c2 = { ...c }
        c2.sharedProduct = c.sharedProduct.filter(p => !this.s || c.name.toLowerCase().includes(this.s) || p.name.toLowerCase().includes(this.s))
        return c2
      })
      return t2
    },
    toggle (type) {
      this.visibility[type] = !this.visibility[type]
    },
    isMatch(prod, cat, type) {
      let s = this.s
      if (!s) {
        return true
      }
      if (prod && prod.name.toLowerCase().includes(s)) {
        return true
      }
      if (cat && cat.name.toLowerCase().includes(s)) {
        return true
      }
      if (type && type.title.toLowerCase().includes(s)) {
        return true
      }
      return false
    },
    productTypeClass(productType, cls) {
      if (cls === 'templateProduct') {
        return 'btn btn-default templateProduct'
      }
      let s = 'btn btn-'
      let t = parseInt(productType.type, 10)
      let st = parseInt(productType.subtype, 10)
      if (t === 0) {
        switch (st) {
          case 0:
            s += 'primary'
            break
          case 1:
          case 1001:
            s += 'info'
            break
          case 2:
            s += 'info'
            break
          case 6:
          case 7:
            s += 'danger'
            break
          case 8:
            s += 'default'
            break
          default:
            s += 'primary'
            break
        }
      } else {
        switch (st) {
          case 0:
            s += 'success'
            break
          case 1:
          case 1001:
            s += 'success'
            break
          case 2:
            s += 'success'
            break
          case 3:
            s += 'warning'
            break
          case 4:
            s += 'info'
            break
          default:
            s += 'default'
            break
        }
      }
      s += ' ' + cls + ' ' + st + ' ' + t
      return s
    },
    processTemplates () {
      let $this = this
      this.productTemplates = this.allTemplates.filter(t => !(t.shopid === $this.productLibraryShopId))
      const productLibraryData = this.allTemplates.filter(t => (t.shopid === $this.productLibraryShopId))
      if (productLibraryData) {
        this.productLibraryTemplate = productLibraryData[0]
        this.productLibraryTags = productLibraryData[0].searchkeywords
        this.productLibraryCategories = productLibraryData[0].sharedCategory.filter(g => g.sharedProduct.filter(p => p.enable_catalog != '0').length > 0)
      }
    },
    async loadProductLibraryCategory () {
      this.selectedLibraryCategoryProducts = []
      let response
      this.loading = true
      try {
        if (this.baseDomain === 'https://johkutest.jalusta.com/') {
          response = await axios.get('https://johku.com/' + this.productLibraryShopId + '/' + this.locale + '/categories/' + this.selectedLibraryCategory.id +'/allproducts.json?details=true')
        } else {
          response = await axios.get(this.baseDomain + this.productLibraryShopId + '/' + this.locale + '/categories/' + this.selectedLibraryCategory.id +'/allproducts.json?details=true')
        }
      } catch(e) {}
      this.loading = false
      if (response) {
        this.selectedLibraryCategoryProducts = response.data.map((item) => {
          item.product.tags = this.parseResultTags(item.product.sharedTag)
          return item
        })
      }
    },
    linkedProductClick (id) {
      this.showPreviewModal(id)
    },
    tagClick(tag) {
      this.selectedPreviewProduct = null
      this.selectedLibraryProduct = null
      this.selectedLibraryCategory = null

      const matchingLibraryTags = this.productLibraryTags.filter(str => str.includes(tag))
      if (matchingLibraryTags.length) {
        this.selectedLibraryTag = matchingLibraryTags.sort((a, b) => a.length - b.length).pop()
      } else {
        this.selectedLibraryTag = tag
      }

      this.searchThisProductLibrary(tag)
      this.hidePreviewModal()
    },
    deselectTag(tag) {
      this.selectedLibraryTag = ''
      if (!this.productLibrarySearchQuery) {
        this.searchActive = false
      } else {
        this.searchThisProductLibrary(this.productLibrarySearchQuery)
      }
    },
    async loadProductLibraryProduct (id) {
      let response
      this.loading = true
      try {
        if (this.baseDomain === 'https://johkutest.jalusta.com/') {
          response = await axios.get('https://johku.com/' + this.productLibraryShopId + '/' + this.locale + '/products/' + id +'.json?details=true&storefront=true')
        } else {
          response = await axios.get(this.baseDomain + this.productLibraryShopId + '/' + this.locale + '/products/' + id +'.json?details=true&storefront=true')
        }
      } catch(e) {
        console.log(e)
        this.loading = false
        return
      }
      if (response) {
        this.selectedLibraryProductData = response.data
        this.selectedLibraryProductData.tags = this.parseResultTags(this.selectedLibraryProductData.sharedTag)
      }
      this.loading = false
    },
    previewProductUrl(product) {
      return 'https://' + this.productLibraryShopId +'.johku.com/' + this.locale + '/' + product.canonical
    },
    async loadProductTemplates () {
      let response
      this.loading = true
      try {
        if (this.baseDomain === 'https://johkutest.jalusta.com/') {
          response = await axios.get('https://johku.com/ceepeli/' + this.locale + '/producttemplates.json?apikey=fde5bcdbc15ce17e200ce223d8d55220')
        } else {
          response = await axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/producttemplates.json?apikey=' + this.apiKey)
        }
      } catch(e) {
        console.log(e)
      }
      if (response) {
        this.allTemplates = response.data
        this.processTemplates()
      }
      this.loading = false
    },
    async loadProductTypes () {
      let response
      this.loading = true
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/products.json?types=objects&scope=base&apikey=' + this.apiKey)
      } catch(e) {}
      if (response) {
        this.allProductTypes = response.data
      }
      this.loading = false
    },
    productType (product) {
      if (!this.allProductTypes.length) {
        return ''
      }
      let subtype = product.subtype ? product.subtype : 0
      let displayedtype = product.displayedtype ? product.displayedtype : false
      let type = this.allProductTypes.find(type => type.type === parseInt(product.type) && type.subtype === parseInt(subtype) && (displayedtype === false || displayedtype === type.displayedtype))
      if (type) {
        return type.title
      } else {
        return ''
      }
    },
    async loadCategories (callback) {
      let response
      this.loading = true
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/categories.json?apikey=' + this.apiKey)
      } catch(e) {}
      if (response) {
        this.allCategories = response.data
      }
      if (callback) {
        callback()
      }
      this.loading = false
    }
  },
  watch: {
    selectedLibraryCategory: {
      deep: true,
      handler(newValue,oldValue) {
        this.selectedLibraryProduct = null
        if(newValue && newValue.id != oldValue?.id) {
          this.loadProductLibraryCategory(newValue.id)
        }
      }
    },
    selectedLibraryProduct: {
      deep: true,
      handler(newValue,oldValue) {
        if (newValue) {
          this.focusName()
        }
      } 
    },
    productLibrarySearchQuery(newValue, oldValue) {
      if (this.isNumber(newValue)) {
      } else {
        if (newValue && newValue.length > 2) {
          this.searchProductLibrary(newValue, this)
        }
      }
    }
  },
  mounted () {
    this.loadProductTemplates()
    this.loadProductTypes()
    this.loadCategories(() => {
      if (this.filteredOpenCategories && this.filteredOpenCategories.length === 1) {
        this.selectedCategory = this.filteredOpenCategories[0].id
      }
    })
    if (this.$refs.search) {
      this.$refs.search.focus()
    }
  }
}
</script>